import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Line } from 'react-chartjs-2';

function GraficaTemperaturaPorMaquina({ dataApi, maquina, fechaInicio, fechaFin }) {
  const datosFiltrados = dataApi.filter(d => !maquina || d.maquinaId === maquina);
  const tempPorDia = {};
  datosFiltrados.forEach(d => {
    if (!tempPorDia[d.fecha]) tempPorDia[d.fecha] = [];
    tempPorDia[d.fecha].push(Number(d.temperaturaPromedio));
  });
  const labels = Object.keys(tempPorDia).sort();
  const promedios = labels.map(f => {
    const arr = tempPorDia[f];
    if (arr.length === 0) return 0;
    return arr.reduce((a, b) => a + b, 0) / arr.length;
  });
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Temperatura promedio',
        data: promedios,
        borderColor: 'rgba(249,167,55,1)',
        backgroundColor: 'rgba(249,167,55,0.2)',
        borderWidth: 1, // línea más delgada
        tension: 0.7, // curva más acentuada
        pointRadius: 3,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Temperatura por día (${maquina || 'Todas'})` },
    },
    scales: {
      x: {
        title: { display: true, text: 'Día' },
        ticks: {
          font: { size: 10 },
          maxTicksLimit: 28,
          autoSkip: true,
          stepSize: 1,
        },
        grid: {
          lineWidth: 0.5,
          drawTicks: true,
        },
        offset: false,
      },
      y: { title: { display: true, text: 'Temperatura (°C)' } },
    },
  };
  const filtrosCompletos = maquina && fechaInicio && fechaFin;
  const hayDatos = filtrosCompletos && labels.length > 0 && promedios.some(v => v > 0);
  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Gráfica de temperatura por máquina
      </Typography>
      <Box sx={{ height: 350, overflowX: 'auto', width: '100%' }}>
  {!hayDatos ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            No hay datos para el rango seleccionado
          </Typography>
        ) : (
          <Box sx={{ minWidth: 600, maxWidth: '100%' }}>
            <Line data={chartData} options={options} />
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default GraficaTemperaturaPorMaquina;
